import urlApi from '@/router/urlApiV2'
import urlApiOld from '@/router/urlApi';
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

  // CARREGAR LISTA DE ORDENAÇÃO
  async ordernacaoSearch () {
    let ordernacaoSearch = [
      { value: '', text: 'SELECIONE A ORDENAÇÃO' },
      { value: 'candidato', text: 'NOME ALUNO' },
      { value: 'instrutor', text: 'NOME INSTRUTOR' },
      { value: 'veiculo', text: 'VEÍCULO' },
      { value: 'categoria', text: 'CATEGORIA' },
      { value: 'turno', text: 'TURNO' },
      { value: 'status', text: 'STATUS' }
    ]

    return ordernacaoSearch
  },

  // BUSCAR AULAS POR ALUNO
  async queryResultByCandidato (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/consultar/candidato/nome/' + data.nome, data)
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR AULAS POR INSTRUTOR
  async queryResult (data, callback) {
    Vue.http.get(urlApi + '/aulas/praticas/consultar/filtros?schema='+data.schema+
    '&nome='+data.nome+'&instrutor='+data.instrutor+'&ordenar='+data.ordenar+'&periodo[]='+data.periodo[0]+'&periodo[]='+data.periodo[1])
      .then(response => {
        callback(response.body)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // BUSCAR AULAS POR INSTRUTOR
  async queryResultByInstrutor (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/consultar/instrutor/nome/' + data.instrutor, data)
      .then(response => {
        callback(response.data.dados)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // CANCELAR AULA PRÁTICA
  async cancelAula (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/cancelar/autoescola/' + data.schema + '/id/' + data.aula)
      .then(response => {
        callback(response)
        this.launchToast('fa-warning', response.data.mensagem)
      })
      .catch(error => {
        if (error.status === 400) {
          if (error.data.mensagem === 'Undefined offset: 0') {
            this.launchToast('fa-warning', 'Nenhum registro encontrado!')
          } else {
            this.launchToast('fa-warning', error.data.mensagem)
          }
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  // CANCELAR AULAS EM LOTE
  async cancelarAulasLote (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/cancelar-lote/autoescola/' + data.schema, {
      aulas_ids: data.aulasIds,
      justificativa: data.justificativa
    })
      .then(response => {
        callback(response)
        this.launchToast('fa-check', response.data.mensagem)
      })
      .catch(error => {
        if (error.status === 400 || error.status === 422) {
          this.launchToast('fa-warning', error.data.mensagem || 'Erro de validação')
        } else {
          this.launchToast('fa-warning', 'Ops! Não foi possível realizar o cancelamento em lote!')
        }
        callback(error.data)
      })
  },

  // CARREGAR IMAGENS DAS AULAS PRÁTICAS
  async getFotos (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/consultar/fotos/id/' + data.aula, data)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        if (error.status === 400) {
          this.launchToast('fa-warning', error.data.mensagem)
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },
  async getInfo (data, callback) {
    Vue.http.post(urlApi + '/au')
  },

  // DELETAR IMAGENS DAS AULAS PRÁTICAS
  async deletePhoto (data, callback) {
    Vue.http.post(urlApi + '/aulas/praticas/deletar/fotos/id/' + data.idAnotacao, data)
      .then(response => {
        callback(response)
        this.launchToast('fa-check', 'Imagem deletada com sucesso!')
      })
      .catch(error => {
        if (error.status === 400) {
          this.launchToast('fa-warning', error.data.mensagem)
        } else {
          this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!')
        }
        callback(error.data)
      })
  },

  async setAnnotationClass (data, callback) {
    Vue.http.post(urlApi + `/aulas/praticas/criar/anotacao/id/${data.idAnotacao}`, data)
      .then(response => {
        callback(response)
        this.launchToast('fa-check', 'Aula criada com sucesso!')
      })
      .catch(error => {
        callback(error.data)
        this.launchToast('fa-warning', error.data.mensagem)
      })
  },
  // async getAlunoInfo (alunoId, callback) {
  //   Vue.http.get(urlApi + '/aulas/praticas/realizada/' + idAulaPratica).then(function (response) {
  //     callback(response)
  //   })
  // },

  // ALERT TOAST
  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    })
  },

}
